import Sidebar from "../../components/sidebar/Sidebar";
import Navbar from "../../components/navbar/Navbar";
import "./home.scss";
import Widget from "../../components/widget/Widget";
import Featured from "../../components/featured/Featured";
import Chart from "../../components/chart/Chart";
import Table from "../../components/table/Table";
import TeacherChart from "../../components/chart/TeacherChart";
import AdminChart from "../../components/chart/AdminChart";

const Home = () => {

  // console.log(localStorage.getItem('data'), 'logged data')
  return (
  
    <div className="home">
      <Sidebar />
      <div className="homeContainer">
        <Navbar />
        <div className="widgets">
          <Widget type="schools" />
          <Widget type="teachers" />
          <Widget type="schooladmins" />
          <Widget type="student" />
        </div>
        <div className="charts">
          <Featured />
          <Chart title="Last 6 Months (Revenue)" aspect={2 / 1} />
        </div>
        <div className="charts">
          <TeacherChart title="Last 6 Months (Revenue)" aspect={2 / 1} />
        </div>
        {/* <div className="charts">
          <AdminChart title="Last 6 Months (Revenue)" aspect={2 / 1} />
        </div> */}
      </div>
    </div>
  );
};

export default Home;
